export default __webpack_public_path__ + "static/media/search_grey_icon.e838523e.svg";